import React from 'react'
import LinearProgress from '@material-ui/core/LinearProgress'
import { lighten, withStyles } from '@material-ui/core/styles'

const BAR_COLOR = '#1e88e5'

const Bar = withStyles({
  root: {
    flex: 1,
    minWidth: 72,
    height: 8,
    borderRadius: 4,
    backgroundColor: lighten(BAR_COLOR, 0.8)
  },
  bar: {
    borderRadius: 4,
    backgroundColor: BAR_COLOR
  }
})(LinearProgress)

const percentOf = (value, max) => {
  const total = Number(max)
  return total > 0 ? (Math.max(Number(value) || 0, 0) / total) * 100 : null
}

// Never round a partly filled car to 0% or 100%, so those labels always mean truly empty or full
export const formatPercent = (value, max) => {
  const percent = percentOf(value, max)
  if (percent === null) return '—'
  if (percent > 0 && percent < 1) return '<1%'
  if (percent > 99 && percent < 100) return '99%'
  return `${Math.round(percent)}%`
}

const ProgressBar = ({ value, max }) => (
  <div style={{ display: 'flex', alignItems: 'center' }}>
    <Bar variant="determinate" value={Math.min(percentOf(value, max) ?? 0, 100)} />
    <span style={{ minWidth: 36, marginLeft: 8, textAlign: 'right', fontSize: 12, whiteSpace: 'nowrap' }}>{formatPercent(value, max)}</span>
  </div>
)

export default ProgressBar
